export default __webpack_public_path__ + "68f64c77e8378720d75e430bb198c55b.png";